import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c7ebf780")

_pushScopeId("data-v-c7ebf780")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GradientDefs = _resolveComponent("GradientDefs")
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")
  const _directive_contextmenu = _resolveDirective("contextmenu")

  return (_openBlock(), _createBlock("div", {
    class: ["editable-element-shape", { 'lock': _ctx.elementInfo.lock }],
    style: {
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    }
  }, [
    _createVNode("div", {
      class: "rotate-wrapper",
      style: { transform: `rotate(${_ctx.elementInfo.rotate}deg)` }
    }, [
      _withDirectives(_createVNode("div", {
        class: "element-content",
        style: {
          opacity: _ctx.elementInfo.opacity,
          filter: _ctx.shadowStyle ? `drop-shadow(${_ctx.shadowStyle})` : '',
          transform: _ctx.flipStyle,
        },
        onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleSelectElement($event))
      }, [
        _createVNode(_component_SvgWrapper, {
          overflow: "visible",
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height
        }, {
          default: _withId(() => [
            (_ctx.elementInfo.gradient)
              ? (_openBlock(), _createBlock("defs", _hoisted_1, [
                  _createVNode(_component_GradientDefs, {
                    id: `editabel-gradient-${_ctx.elementInfo.id}`,
                    type: _ctx.elementInfo.gradient.type,
                    color1: _ctx.elementInfo.gradient.color[0],
                    color2: _ctx.elementInfo.gradient.color[1],
                    rotate: _ctx.elementInfo.gradient.rotate
                  }, null, 8, ["id", "type", "color1", "color2", "rotate"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("g", {
              transform: `scale(${_ctx.elementInfo.width / _ctx.elementInfo.viewBox}, ${_ctx.elementInfo.height / _ctx.elementInfo.viewBox}) translate(0,0) matrix(1,0,0,1,0,0)`
            }, [
              _createVNode("path", {
                "vector-effect": "non-scaling-stroke",
                "stroke-linecap": "butt",
                "stroke-miterlimit": "8",
                "stroke-linejoin": "",
                d: _ctx.elementInfo.path,
                fill: _ctx.elementInfo.gradient ? `url(#editabel-gradient-${_ctx.elementInfo.id})` : _ctx.elementInfo.fill,
                stroke: _ctx.outlineColor,
                "stroke-width": _ctx.outlineWidth,
                "stroke-dasharray": _ctx.outlineStyle === 'dashed' ? '10 6' : '0 0'
              }, null, 8, ["d", "fill", "stroke", "stroke-width", "stroke-dasharray"])
            ], 8, ["transform"])
          ]),
          _: 1
        }, 8, ["width", "height"])
      ], 36), [
        [_directive_contextmenu, _ctx.contextmenus]
      ])
    ], 4)
  ], 6))
})